import MenuSelector from "@arelia-components/ui-atoms/menu-selector/MenuSelector";
import { MenuType } from "@arelia-components/ui-atoms/menu-selector/models";
import { Box, Button } from "@mui/material";
import { sortByMenu } from "../constant";
import { CampaignSorting } from "../models";
import { AddOutlined as AddOutlinedIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { PATHS } from "src/routes";
import { useState } from "react";
import { useTwilioConfigAPI, useBrandRegistrationStatusAPI } from "../../../../features/fans/settings/settings.api";
import PurchaseMessagesDialog from "../../../../components/SubscriptionDetails/components/SubscriptionInfo/PurchaseMessagesDialog";

type Props = {
  sortCampaignsBy: CampaignSorting;
  setSortCampaignsBy: (value: CampaignSorting) => void;
}

export function CampaignFilters({ sortCampaignsBy, setSortCampaignsBy }: Props) {
  const [purchaseModalOpen, setPurchaseModalOpen] = useState(false);
  const { data: twilioConfig } = useTwilioConfigAPI();
  const { data: registrationStatus } = useBrandRegistrationStatusAPI(true, false);

  const handleOpenModal = () => setPurchaseModalOpen(true);
  const handleCloseModal = () => setPurchaseModalOpen(false);

  const navigate = useNavigate();

  const availableMessages = ((twilioConfig?.messageLimitCurrent ?? 0) + (twilioConfig?.additionalMessageLimit ?? 0));
  
  const smsSetupComplete = registrationStatus?.completed === true;

  return (
    <Box sx={smsSetupComplete ? styles.wrapper : styles.wrapperCompact}>
      <Box sx={styles.filters}>
        <MenuSelector
          menuType={MenuType.contained}
          menuItems={sortByMenu}
          selectedValue={sortCampaignsBy}
          onClick={setSortCampaignsBy}
        />
        <Button
          variant="contained"
          color="secondary"
          startIcon={<AddOutlinedIcon color="error" />}
          onClick={() => navigate(PATHS.CAMPAIGN_LIST + "/new")}
        >
          Add campaign
        </Button>
      </Box>
      {smsSetupComplete && (
        <Box sx={styles.messagesContainer}>
          <Button variant="contained" color="secondary" onClick={handleOpenModal}>
            Buy More Messages
          </Button>
          <Box>
            <b>{availableMessages.toLocaleString()}</b>&nbsp; SMS messages are available this month.
          </Box>
        </Box>
      )}
      {purchaseModalOpen && <PurchaseMessagesDialog onClose={handleCloseModal} />}
    </Box>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%"
  },
  wrapperCompact: {
    display: "flex",
    justifyContent: "flex-start",
    width: "auto",
    flexShrink: 0,
    paddingRight: "24px"
  },
  filters: {
    display: "flex",
    gap: "20px",
    alignItems: "center"
  },
  messagesContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: "12px"
  }
};